import { apiSlice } from "../api/apiSlice";

export const adelantarPagoApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    crearLinkMecadoPago: builder.mutation({
      query: (adelantarPago)=>({
        url: 'mp-link-pago',
        method: 'post',
        body: adelantarPago
      })
    })
  })
})

export const { useCrearLinkMecadoPagoMutation} = adelantarPagoApi;